import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// `.btn` from styles/primitives.css. variant → btn-primary | btn-ghost |
// btn-soft | btn-danger | btn-danger-solid | btn-ok, size → btn-sm | btn-lg.
const classes = (variant, size, className) =>
  ['btn', variant && `btn-${variant}`, size && `btn-${size}`, className].filter(Boolean).join(' ');

const shape = {
  variant: PropTypes.oneOf(['primary', 'ghost', 'soft', 'danger', 'danger-solid', 'ok']),
  size: PropTypes.oneOf(['sm', 'lg']),
  className: PropTypes.string,
  children: PropTypes.node,
};

// forwardRef so callers can focus a button (the confirm dialog does).
const Button = React.forwardRef(function Button({ variant, size, className, children, ...rest }, ref) {
  return (
    <button ref={ref} className={classes(variant, size, className)} {...rest}>
      {children}
    </button>
  );
});
Button.propTypes = shape;
export default Button;

// Same skin on a router link — for navigation that looks like a button.
export function LinkButton({ variant, size, className, children, ...rest }) {
  return (
    <Link className={classes(variant, size, className)} {...rest}>
      {children}
    </Link>
  );
}
LinkButton.propTypes = { ...shape, to: PropTypes.string.isRequired };

// Same skin on a plain anchor — for downloads and external files.
export function AnchorButton({ variant, size, className, children, ...rest }) {
  return (
    <a className={classes(variant, size, className)} {...rest}>
      {children}
    </a>
  );
}
AnchorButton.propTypes = shape;
